import { store } from "../redux/store";
import { dataConstants } from "../constants/data-constants";
import { axiosClient } from "./axios-config";
import { setErrorMsg } from "../redux/common/common.actions";
import packageJson from "../../package.json";

axiosClient.interceptors.request.use(
  (request) => {
    if (isHandlerEnabled(request)) {
      request.headers["Content-Type"] = "application/json";
      if (
        request.url !== dataConstants.loginUrl ||
        request.url !== dataConstants.forgotPasswordUrl
      ) {
        const userdata = store.getState().user;
        if (request.url === dataConstants.refreshTokenUrl) {
          const refreshToken = userdata.authData.refresh_token;
          request.headers["Authorization"] = `Bearer ${refreshToken}`;
        } else {
          const accessToken = userdata.authData.access_token;
          request.headers["Authorization"] = `Bearer ${accessToken}`;
        }
      }
      request.headers["Api-Version"] = "1.5.0";
      request.headers["Client-Type"] = "web";
    }
    return request;
  },
  (error) => {
    store.dispatch(
      setErrorMsg("Something went wrong , please try again later.")
    );
    return Promise.reject(error);
  }
);

const isHandlerEnabled = (config: any) => {
  // eslint-disable-next-line no-prototype-builtins
  return config.hasOwnProperty("handlerEnabled") && !config.handlerEnabled
    ? false
    : true;
};
